import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxPermissionsService } from 'ngx-permissions';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ColDef, ColumnApi, GridApi } from 'ag-grid-enterprise';
import { ActionItemsGridRowRendererComponent } from 'src/app/components/_shared/action-items-grid-row-renderer/action-items-grid-row-renderer.component';
import { UserService } from 'src/app/_services/user/user.service';
import { ApprovalService } from "src/app/_services/approval/approval.service";

@Component({
  selector: 'app-onboarding-approval',
  templateUrl: './onboarding-approval.component.html',
  styleUrls: ['./onboarding-approval.component.scss']
})
export class OnboardingApprovalComponent implements OnInit {
  tenantId: string;
  userDetails: any;
  userCreationForm
  defaultColDef: any;
  deleteConfirmationMsg = 'Are you sure you want to delete';
  rowSelection: any
  dataSource: any;
  public columnDefs: ColDef[];
  modeAction: number = 1; //1 - create // 2 - update
  sampleGridFrameworkComponents: any;
  selectedCheckboxData = [];
  private api: GridApi;
  private columnApi: ColumnApi;
  selectedRow: any;
  rowData: any;
  data: any;
  userData: any;
  userId: any;
  usersForm;
  requester: any;
  TodayDate: string;
  license: boolean;
  usersData: any = [];
  usersCreationData: any = [];
  systemRequiredBooleanValue: any;
  userFullName: any;
  userCreationId: any;
  route: any;

  constructor(
    private formBuilder: FormBuilder,
    private storageService: LocalStorageService,
    private router: Router,
    private snackBar: MatSnackBar,
    private userService: UserService,
    private approvalService: ApprovalService,
  ) {
    {
      this.defaultColDef = {
        flex: 1,
        minWidth: 100,
        resizable: true,
      };
      this.rowSelection = 'multiple';
      this.columnDefs = this.createColumnDefs();

      this.sampleGridFrameworkComponents = {
        actionRowRendererComponent: ActionItemsGridRowRendererComponent
      };
    }
    // this.userCreationForm = this.formBuilder.group({
    //   id: new FormControl(''),
    //   requesterId: new FormControl(''),
    //   requesterName: new FormControl(''),
    //   requestedDate: new FormControl(''),
    //   status: new FormControl(''),
    //   userId: new FormControl(''),
    //   firstName: new FormControl(''),
    //   lastName: new FormControl(''),

    // });


    this.userCreationForm = this.formBuilder.group({
      id: new FormControl(''),
      requesterId: new FormControl({ value: '', disabled: true }),
      requesterName: new FormControl({ value: '', disabled: true }),
      requestedDate: new FormControl({ value: '', disabled: true }),
      localId: new FormControl({ value: '', disabled: true }),
      status: new FormControl({ value: '', disabled: true }),
      userId: new FormControl({ value: '', disabled: true }),
      firstName: new FormControl({ value: '', disabled: true }),
      middleName: new FormControl({ value: '', disabled: true }),
      lastName: new FormControl({ value: '', disabled: true }),
      emailId: new FormControl({ value: '', disabled: true }),
      remarks: new FormControl({ value: '', disabled: true }),
      addedToBioMetrics: new FormControl({ value: '', disabled: true }),
      licenseType: new FormControl({ value: '', disabled: true }),
      licenseRequired: new FormControl({ value: '', disabled: true }),
      licenseAllocation: new FormControl({ value: '', disabled: true }),
      systemRequiredBoolean: new FormControl({ value: '', disabled: true }),
      systemRequired: new FormControl({ value: '', disabled: true }),
      ndaSignedDate: new FormControl({ value: '', disabled: true }),
      biometric: new FormControl({ value: '', disabled: true }),
      ismsTraining: new FormControl({ value: '', disabled: true }),
      ismsAgreement: new FormControl({ value: '', disabled: true }),
      passwordBoolean: new FormControl({ value: '', disabled: true }),
      emailIdRequired: new FormControl({ value: '', disabled: true }),
      ndaSignedBoolean: new FormControl({ value: '', disabled: true }),
      domainUserId: new FormControl({ value: '', disabled: true }),
      displayName: new FormControl({ value: '', disabled: true }),
      department: new FormControl({ value: '', disabled: true }),
      phoneNo: new FormControl({ value: '', disabled: true }),
      location: new FormControl({ value: '', disabled: true }),
      joinDate: new FormControl({ value: '', disabled: true }),
      permanentOrContractor: new FormControl({ value: '', disabled: true }),
      alternateEmailId: new FormControl({ value: '', disabled: true }),
      supervisorId: new FormControl({ value: '', disabled: true }),
      supervisonName: new FormControl({ value: '', disabled: true }),
      currentDesignation: new FormControl({ value: '', disabled: true }),
      careerStartDate: new FormControl({ value: '', disabled: true }),
      managerId: new FormControl({ value: '', disabled: true }),
      managerName: new FormControl({ value: '', disabled: true }),
      totalExperience: new FormControl({ value: '', disabled: true }),
      currentExperience: new FormControl({ value: '', disabled: true }),
      roles: new FormControl({ value: '', disabled: true }),
      birthDate: new FormControl({ value: '', disabled: true }),
    });
  }

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.userDetails = JSON.parse(this.storageService.get('currentUser'));
    this.getUserCreationforApproval();
  }

  get f() {
    return this.userCreationForm.controls;
  }

  onSelectionChanged(event) {
    console.log(event)
    this.selectedCheckboxData = [];
    let select = event.api.getSelectedNodes();
    for (let item of select) {
      this.selectedCheckboxData.push(item.data);
    }
  }

  // one grid initialisation, grap the APIs and auto resize the columns to fit the available space  
  onGridReady(params: any) {
    this.api = params.api;
    this.columnApi = params.columnApi;
    this.api.sizeColumnsToFit();
  }

  isFirstColumn(params) {
    const displayedColumns = params.columnApi.getAllDisplayedColumns();
    const thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
  }


  private createColumnDefs() {
    return [
      {
        headerName: "Requester Name",
        field: "requesterName",
        filter: true,
        editable: false,
        sortable: true,
        headerCheckboxSelection: this.isFirstColumn,
        checkboxSelection: this.isFirstColumn,
      },
      {
        headerName: 'Requested Date',
        field: 'requestedDate',
        filter: true,
        editable: false,
        sortable: true
      },
      {
        headerName: 'New User',
        field: 'firstName',
        filter: true,
        editable: false,
        sortable: true
      },
      {
        headerName: 'Satus',
        field: 'status',
        filter: true,
        editable: false,
        sortable: true,
      },
      {
        headerName: 'Action',

        cellRenderer: (params) => {

          if (params.data.inTime != "" && params.data.outTime != "") {
            const spanElement = document.createElement('div');
            spanElement.classList.add('d-flex');
            spanElement.innerHTML = `<button type="button" id="approvalBtn" class="btn btn-success" style="margin-right: 5px">Approval</button> <button type="button" id="cancelBtn"class="btn-danger btn">Cancel</button>`;
            spanElement.addEventListener('click', ($event) => {

              if ($event.target && $event.target['id'] == "approvalBtn") {
                this.userId = params.data.employeeId;
                $event.preventDefault();
                let element: HTMLElement = document.getElementById('confimationBtn');
                element.click();
              } else {
                $event.preventDefault();
                console.log('456');
              }
              if ($event.target && $event.target['id'] == "cancelBtn") {
                this.userId = params.data.employeeId;

                $event.preventDefault();
                let element: HTMLElement = document.getElementById('cancelConfirmationBtn');
                element.click();
              } else {
                $event.preventDefault();
                console.log('456');
              }

            });
            return spanElement;

          }


        }

      },
    ]
  }

  getUserCreationforApproval() {
    let filterType = 'onboardingapproval';
    this.approvalService.getApprovals(filterType).subscribe((response: any) => {
      this.rowData = response.userCreations;
    })
  }

  //Approve New User
  approveUser() {
    let data = this.rowData[0];
    let id = data.id;
    let userCreationData = {
      id: data.id,
      firstName: data.firstName,
      lastName: data.lastName,
      remarks: data.remarks,
      requestedDate: data.requestedDate,
      requesterId: data.requesterId,
      requesterName: data.requesterName,
      status: "approved",
      userId: data.userId,
      biometric: data.biometric,
      domainUserId: data.domainUserId,
      emailIdRequired: data.emailIdRequired,
      licenseAllocation: data.licenseAllocation,
      licenseRequired: data.licenseRequired,
      licenseType: data.licenseType,
      ndaSignedBoolean: data.ndaSignedBoolean,
      ndaSignedDate: data.ndaSignedDate,
      passwordBoolean: data.passwordBoolean,
      systemRequired: data.systemRequired,
      systemRequiredBoolean: data.systemRequiredBoolean,
      ismsAgreement: data.ismsAgreement,
      ismsTraining: data.ismsTraining,

    }
    this.userService.updateUserCreation(id, userCreationData).subscribe((response) => {
      if (response) {
        this.getUserCreationforApproval();
      }
    })
  }

  cancelUserOnboarding() {
    let data = this.rowData[0];
    let id = data.id;
    let userCreationData = {
      id: data.id,
      firstName: data.firstName,
      lastName: data.lastName,
      remarks: data.remarks,
      requestedDate: data.requestedDate,
      requesterId: data.requesterId,
      requesterName: data.requesterName,
      status: "withHrTeam",
      userId: data.userId,
    }
    this.userService.updateUserCreation(id, userCreationData).subscribe((response) => {
      if (response) {
        this.getUserCreationforApproval();
      }
    })
  }

  editOpenModal() {
    this.modeAction = 2;
    this.userCreationForm.patchValue(this.selectedCheckboxData[0]);
    this.userService.getUser(this.selectedCheckboxData[0].userId).subscribe((response) => {
      this.userFullName = response.firstName + " " + response.middleName + " " + response.lastName;
      this.usersData = response;
      this.userCreationForm.patchValue({
        userId: response.userId,
        localId: response.localId,
        password: response.password,
        firstName: response.firstName,
        middleName: response.middleName,
        lastName: response.lastName,
        displayName: response.displayName,
        department: response.department,
        alternateEmailId: response.alternateEmailId,
        phoneNo: response.phoneNo,
        location: response.location,
        joinDate: response.joinDate,
        permanentOrContractor: response.permanentOrContractor,
        supervisonName: response.supervisorId + ' . ' + response.supervisonName,
        currentDesignation: response.currentDesignation,
        archived: true,
        managerName: response.managerName,
        birthDate: response.birthDate,
      });
      this.userCreationForm.value.emailId = response.emailId;
      this.userCreationForm.value.localId = response.localId;
      this.userCreationForm.patchValue(this.userCreationForm.value);
    })
    // this.userCreationForm.patchValue(this.userCreationForm.value)
  }

  getUserCreationById(id) {
    this.userService.getUserCreationById(id).subscribe((response) => {
      this.usersCreationData = response;
      if (response) {
        this.userCreationForm.patchValue({
          requesterId: response.requesterId + " . " + response.requesterName,
          requestedDate: response.requestedDate,
          userId: response.userId + " . " + response.firstName + " " + response.lastName,
          status: response.status,
          remarks: response.remarks,
          biometric: response.biometric,
          licenseType: response.licenseType,
          licenseRequired: response.licenseRequired,
          ismsTraining: response.ismsTraining,
          passwordBoolean: response.passwordBoolean,
          ismsAgreement: response.ismsAgreement,
          licenseAllocation: response.licenseAllocation,
          domainUserId: response.domainUserId,
        })
      }

      if (response.licenseRequired === true) {
        this.license = true;
      }

      this.systemRequiredBooleanValue = response.systemRequiredBoolean;
      let systemRequiredValue = response.systemRequired;
      let userId = response.userId;
      this.userService.getUser(userId).subscribe((response) => {
        this.userFullName = response.firstName + " " + response.middleName + " " + response.lastName;
        this.usersData = response;
        this.usersForm.patchValue({
          userId: response.userId,
          localId: response.localId,
          password: response.password,
          firstName: response.firstName,
          middleName: response.middleName,
          lastName: response.lastName,
          displayName: response.displayName,
          department: response.department,
          alternateEmailId: response.alternateEmailId,
          phoneNo: response.phoneNo,
          location: response.location,
          joinDate: response.joinDate,
          permanentOrContractor: response.permanentOrContractor,
          supervisonName: response.supervisorId + ' . ' + response.supervisonName,
          currentDesignation: response.currentDesignation,
          archived: true,
          managerName: response.managerName,
          birthDate: response.birthDate,
        });
        this.userCreationForm.value.emailId = response.emailId;
        this.userCreationForm.value.localId = response.localId;
        this.userCreationForm.patchValue(this.userCreationForm.value);
      })
    })
  }
}
